import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "Seed.svg",
  "use": "Seed.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"Seed.svg\"><path d=\"M25,54c-3.8559,0-3.9035-2.09-7-3s-4.09-1.9035-5-5-3-3.1442-3-7C10,26.0862,41.125,10,46,10a7.8977,7.8977,0,0,1,8,8C54,22.875,37.9139,54,25,54ZM15.0028,38.8319c.0164,1.2776,1.1311,1.4716,1.6562.84,5.9332-7.1351,18.1715-17.1129,26.1931-23a.3755.3755,0,0,0-.3554-.6542C34.4642,19.2522,14.9008,30.8518,15.0028,38.8319Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol